import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { PRIMARY } from "../../../../vars/vars";

const InfoCard = ({ photo, name, to }) => (
  <Wrapper>
    <Car>
      <img src={photo} alt={name} />
    </Car>
    <Data>
      <Header>{name}</Header>
      {to && <StyledLink to={to}>View all parts</StyledLink>}
    </Data>
  </Wrapper>
);

export default InfoCard;

const Wrapper = styled.div`
  margin-bottom: 15px;
  background-color: #222222;
  width: 100%;
  height: 200px;
  position: relative;
  display: flex;
  aligin-items: center;
  overflow: hidden;
  border-radius: 5px;

  @media (min-width: 576px) {
    height: 180px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
  @media (min-width: 768px) {
    height: 120px;
  }
  @media (min-width: 1024px) {
    height: 150px;
  }
  @media (min-width: 1200px) {
    height: 200px;
  }
`;

const Car = styled.div`
  hight: 100%;
  width: 100%;
  max-height: 200px;

  img {
    object-fit: cover;
    hight: 100%;
    width: 100%;
    max-height: 200px;
  }
  @media (min-width: 576px) {
    img {
      height: 180px;
      border-right: 2px solid ${PRIMARY};
    }
  }
  @media (min-width: 768px) {
    img {
      height: 120px;
    }
  }
  @media (min-width: 1024px) {
    img {
      height: 150px;
    }
  }
  @media (min-width: 1200px) {
    img {
      height: 200px;
    }
  }
`;

const Header = styled.h4`
  color: #fff;
  padding: 0 15px 0;
  font-weight: 400;
  margin: 0 0 1em;
  font-size: 19px;
  line-height: 1.3;
  text-align: center;
  @media (min-width: 768px) {
    font-size: 14px;
  }
  @media (min-width: 1024px) {
    font-size: 19px;
  }
`;

const Data = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgb(34, 34, 34, 0.7);
  width: 100%;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 50;

  @media (min-width: 576px) {
    background-color: #222222;
    width: 50%;
    left: 50%;
    transform: translate(0, -50%);
  }
`;

const StyledLink = styled(Link)`
  display: block;
  margin-bottom: 5px;
  color: white;
  background-color: #50be19;
  text-transform: uppercase;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 16px;
  border-radius: 3px;

  &:hover {
    background-color: #48ab16;
    color: white;
  }

  @media (min-width: 768px) {
    padding: 5px 10px;
  }
`;
